import React, { useEffect, useState } from "react";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import "../../../styles/dashboard/roles/RolesIndex.css";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import {
  RazorCheckBox,
  RazorInputField,
  RazorToggleSlide,
} from "../../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import {
  editRoleFunc,
  getModulePermissions,
  getSingleRole,
} from "../../../redux/role";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import {
  arraysHaveDifferences,
  capitalizeFirstLetter,
  getTruePermissions,
  hasSpecialCharactersOrNumbers,
  SPECIAL_ROLES,
} from "../../../utils/Helper";
import { useNavigate } from "react-router-dom";
import { getAllAdminUsers } from "../../../redux/users";

const EditRoleIndex = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [roleInfo, setRoleInfo] = useState<any>({});
  const { loading, loading_modules, module_permission, loading_create } =
    useSelector((state: RootState) => state.roles);
  const { admin_users } = useSelector((state: RootState) => state.users);

  type detailProps = {
    name: string;
    permissions: string[];
    users: string[];
    description: string;
  };

  const [details, setDetails] = useState<detailProps>({
    name: "",
    permissions: [],
    users: [],
    description: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const handleAddToList = (param: string) => {
    // let newList;
    if (details?.permissions?.includes(param)) {
      const newList = details?.permissions?.filter(
        (chi: string) => chi !== param
      );
      setDetails((prev) => {
        return { ...prev, permissions: newList };
      });
    } else {
      const newList = [...details?.permissions, param];
      setDetails((prev) => {
        return { ...prev, permissions: newList };
      });
    }
  };

  useEffect(() => {
    if (module_permission?.length < 1) {
      dispatch(getModulePermissions({}) as any);
    }
    if (admin_users?.length < 1) {
      dispatch(getAllAdminUsers({}) as any);
    }
  }, [module_permission?.length, admin_users?.length, dispatch]);

  const getRoleDetails = React.useCallback(
    async (param: any) => {
      const obj = {
        id: param,
      };
      const data = await dispatch(getSingleRole(obj) as any);

      if (data?.payload?.data?.status) {
        // console.log(data?.payload?.data?.data);
        const obj = data?.payload?.data?.data;
        setRoleInfo(obj);
        // if (obj?.role === "super_admin" ) {
        if (SPECIAL_ROLES?.includes(obj?.role)) {
          navigate(ALL_ROUTES?.DASHBOARD_ROLES);
        } else {
          setDetails((prev) => {
            return {
              ...prev,
              name: obj?.role?.replaceAll("_", " "),
              description: obj?.description,
              permissions: getTruePermissions(obj?.defined_permissions),
              users: addLabelValue(obj?.users),
            };
          });
        }
      }
    },
    [dispatch, navigate]
  );

  useEffect(() => {
    const id = localStorage?.getItem("roleKey") || "";
    if (id) {
      getRoleDetails(id);
    } else {
      navigate(ALL_ROUTES?.DASHBOARD_ROLES);
    }
  }, [getRoleDetails, navigate]);

  const addLabelValue = (list?: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return { ...chi, label: chi?.username, value: chi?.id };
      });
      return newList;
    }
  };

  const filterListFunc = (list: any) => {
    if (list?.length > 0) {
      const filterList = list?.filter((chi: any) => chi?.status !== "Pending");
      // console.log(filterList);
      return filterList;
    }
  };

  const getListUserId = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => chi?.id);
      return newList;
    }
  };

  const handleSubmit = async () => {
    const obj = {
      ...details,
      users: getListUserId(details?.users) || [],
      role_id: localStorage?.getItem("roleKey") || "",
    };
    const data = await dispatch(editRoleFunc(obj) as any);

    if (data?.payload?.data?.status) {
      navigate(ALL_ROUTES?.DASHBOARD_ROLES);
    }
  };

  return (
    <>
      <DashboardLayoutMain
        loading={loading_modules || loading}
        title="Edit Role"
        back
      >
        {/* title fragment start */}
        {/* <TitleBtnFragment
          className="title-btn"
          //   hideBtn
        //   title="Add New Role"
          btnLabel="Create Role"
          sticky
        /> */}
        {/* title fragment end */}
        {/* add new role index wrap start */}
        <div className="add-new-role-index-wrap-smart-send-box">
          <div className="form-box">
            {/* title fragment start */}
            <TitleBtnFragment
              className="title-btn"
              loading={loading_create}
              btnLabel="Update Role"
              sticky
              disable={
                roleInfo?.role?.replaceAll("_", " ") ===
                  details?.name?.replaceAll("_", " ") &&
                details?.description === roleInfo?.description &&
                !arraysHaveDifferences(
                  getTruePermissions(roleInfo?.defined_permissions),
                  details?.permissions
                ) &&
                !arraysHaveDifferences(
                  getListUserId(addLabelValue(roleInfo?.users)),
                  getListUserId(details?.users)
                )
                  ? true
                  : false
              }
              onBtnClick={handleSubmit}
            />
            {/* title fragment end */}
            {/* two form group start */}
            {/* two form group start */}
            <div className="two-form-group-box">
              <RazorInputField
                color="black-light"
                placeholder="Enter role name"
                label="Role Name"
                onChange={(e: any) => {
                  if (hasSpecialCharactersOrNumbers(e.target.value)) {
                    return;
                  }
                  handleChange(e);
                }}
                name="name"
                value={capitalizeFirstLetter(details?.name)}
                capitalize
              />
            </div>
            <RazorInputField
              color="black-light"
              placeholder="Select team members"
              label="Team Members"
              type="select"
              value={details?.users}
              onChange={(e: any) => {
                setDetails((prev) => {
                  return { ...prev, users: e };
                });
              }}
              selectOption={filterListFunc(admin_users)}
              multi={true}
              style={{ position: "relative", zIndex: 10 }}
            />
            {/* two form group end */}
            <RazorInputField
              color="black-light"
              type="textarea"
              label="Description"
              placeholder="Enter Description"
              onChange={handleChange}
              name="description"
              value={details?.description}
              capitalize
            />

            <div className="role-permission-wrap-box">
              <p className="header-title">Defined Permissions:</p>

              {/* module permissions box wrap start */}
              <div className="module-permissions-box-wrap">
                {module_permission?.map((chi: any, idx: any) => {
                  // Check if all permissions in the category are checked
                  const allCategoryChecked = chi?.permissions?.every(
                    (child: any) => {
                      return details?.permissions?.includes(child?.name);
                    }
                  );

                  // Extract the names from the permission array
                  const permissionNames = chi?.permissions?.map(
                    (child: any) => child?.name
                  );

                  const handleAddAllToList = () => {
                    if (allCategoryChecked) {
                      const newList = details?.permissions?.filter(
                        (child: any) => !permissionNames?.includes(child)
                      );
                      setDetails((prev) => {
                        return { ...prev, permissions: newList };
                      });
                    } else {
                      const newList = [
                        ...details?.permissions,
                        ...permissionNames,
                      ];
                      setDetails((prev) => {
                        return { ...prev, permissions: newList };
                      });
                    }
                  };

                  return (
                    <div key={idx} className="module-permissions-box">
                      <p
                        style={{ textTransform: "capitalize" }}
                        className="module-name"
                      >
                        {chi?.category}
                        <RazorToggleSlide
                          checked={allCategoryChecked}
                          onChange={handleAddAllToList}
                          id={`${idx}-${chi?.category}` as any}
                          color={`black-light`}
                        />
                      </p>
                      {/* permissions box wrap start */}
                      <div className="permission-box-wrap">
                        {chi?.permissions?.map((child: any, i: any) => {
                          return (
                            <div key={`${idx}-${i}`} className="permission-box">
                              <p
                                style={{ textTransform: "capitalize" }}
                                className="name"
                              >
                                {child?.name}
                              </p>
                              <RazorCheckBox
                                checked={details?.permissions?.includes(
                                  child?.name
                                )}
                                onChange={() => {
                                  handleAddToList(child?.name);
                                }}
                                id={`${idx}-${i}-${child?.name}` as any}
                                color="black-light"
                                key={`${idx}-${i}-${child?.name}` as any}
                              />
                            </div>
                          );
                        })}
                      </div>
                      {/* permissions box wrap end */}
                    </div>
                  );
                })}
              </div>
              {/* module permissions box wrap end */}
            </div>
          </div>
          {/* form box end */}
        </div>
        {/* add new role index wrap end */}
      </DashboardLayoutMain>
    </>
  );
};

export default EditRoleIndex;
